type FAQItem = {
  q: string;
};

export const FAQ_TOPICS = [
  'General',
  'Account',
  'Listing',
  'Purchase',
  'Cancellation & Refund',
  'Shipping',
  'Returns',
  'Ratings',
  'Payouts',
  'Trust & Safety',
] as const;
export type FAQTopic = (typeof FAQ_TOPICS)[number];

export const ACCOUNT_FAQ_ITEMS: FAQItem[] = [
  { q: 'How Do I Reset My Password?' },
  { q: 'I forgot my password' },
  { q: 'How Do I Contact Support?' },
  { q: 'What Is GearFocus?' },
  { q: "What Are GearFocus' Terms And Condition" },
  { q: 'Why Is My Account Suspended?' },
];

export const LISTING_FAQ_ITEMS: FAQItem[] = [];
export const PURCHASE_FAQ_ITEMS: FAQItem[] = [];
export const CANCELLATION_REFUND_FAQ_ITEMS: FAQItem[] = [];
export const SHIPPING_FAQ_ITEMS: FAQItem[] = [];
export const RETURNS_FAQ_ITEMS: FAQItem[] = [];
export const RATINGS_FAQ_ITEMS: FAQItem[] = [];
export const PAYOUTS_FAQ_ITEMS: FAQItem[] = [];
export const TRUST_SAFETY_FAQ_ITEMS: FAQItem[] = [];

export const GENERAL_FAQ_ITEMS: FAQItem[] = [
  { q: 'Is it free to create a seller account on GearFocus?' },
  { q: 'How do I create a seller account?' },
  { q: 'How much profit do I make if a product is sold?' },
  { q: 'How do I get paid?' },
  { q: 'How long does it take to get paid?' },
  { q: 'As a seller, can I cancel an order?' },
  { q: 'Are there any nonrefundable fees?' },
  { q: 'How do you avoid scammers?' },
  { q: 'What happens if the seller never ships my item?' },
  { q: 'What if an item is damaged in shipping?' },
  { q: 'Are you required to make a purchase if your offer is accepted?' },
  { q: 'Does GearFocus offer warranties?' },
  { q: 'Does GearFocus facilitate trade internationally?' },
  { q: 'Who pays import duties on International items?' },
  { q: 'How Do Auctions Work?' },
];

export const FAQ_TOPIC_QUESTION_MAP: Record<FAQTopic, FAQItem[]> = {
  Account: ACCOUNT_FAQ_ITEMS,
  Listing: LISTING_FAQ_ITEMS,
  Purchase: PURCHASE_FAQ_ITEMS,
  'Cancellation & Refund': CANCELLATION_REFUND_FAQ_ITEMS,
  Shipping: SHIPPING_FAQ_ITEMS,
  Returns: RETURNS_FAQ_ITEMS,
  Ratings: RATINGS_FAQ_ITEMS,
  Payouts: PAYOUTS_FAQ_ITEMS,
  'Trust & Safety': TRUST_SAFETY_FAQ_ITEMS,
  General: GENERAL_FAQ_ITEMS,
};

export const FAQ_QUESTIONS = Object.values(FAQ_TOPIC_QUESTION_MAP)
  .flat()
  .map((faq) => faq.q);

export const QUESTION_TOPIC_MAP = Object.entries(FAQ_TOPIC_QUESTION_MAP).reduce(
  (acc, entry) => {
    const [topic, faqItems] = entry;
    const questions = faqItems.map((faqItem) => faqItem.q);
    questions.forEach((question) => {
      acc[question] = topic as FAQTopic;
    });
    return acc;
  },
  {} as Record<string, FAQTopic>
);
